import { QueryResult } from './QueryResult';
export var SelectResult;
(function (SelectResult) {
    function make(plan) {
        return { id: plan.id, size: 0, results: [] };
    }
    SelectResult.make = make;
    function add(initial, queryResult) {
        const results = [...initial.results, queryResult];
        return { ...initial, results, size: results.length };
    }
    SelectResult.add = add;
    function get(initial, query) {
        for (const result of initial.results) {
            if (result.name === query.name) {
                switch (result.type) {
                    case "URL":
                        return result;
                    case "INLINE":
                        return QueryResult.Inline.expand(result, query);
                }
            }
        }
    }
    SelectResult.get = get;
})(SelectResult || (SelectResult = {}));
